import { computed } from 'vue';
export default {
  __name: 'StatusCom',
  props: {
    status: {
      type: String,
      default: 'noContent'
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    __expose();
    const props = __props;
    const statusImg = computed(() => props.status === 'noContent' ? require('../../assets/personalspace/no_content.png') : require('../../assets/personalspace/no_network.png'));
    const statusText = computed(() => props.status === 'noContent' ? '暂无内容' : 'Oops...网络失联了, 请检查网络');
    const __returned__ = {
      props,
      statusImg,
      statusText
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
};